import React from 'react';
import { PageToolbar } from '../common';

/**
 * PalletsHeader - Header component for Pallets page
 * Contains: page title, create button, toolbar with filters
 */
const PalletsHeader = ({
  viewMode,
  onToggleView,
  searchTerm,
  onSearchChange,
  onScan,
  statusFilter,
  onStatusFilterChange,
  customerFilter,
  onCustomerFilterChange,
  customers,
  labelFilter,
  onLabelFilterChange,
  labels,
  dateFilter,
  onDateFilterChange,
  filteredCount,
  onCreateClick,
  searchTotals,
  onRefresh,
  isRefreshing,
  autoRefresh,
  onAutoRefreshChange
}) => {
  return (
    <div className="page-header">
      <div className="header-top">
        <h1>Pallets</h1>
        <div className="header-actions">
          <div className="refresh-controls">
            <button
              className={`refresh-btn${isRefreshing ? ' spinning' : ''}`}
              onClick={onRefresh}
              title="Refresh now"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
              </svg>
            </button>
            <label className="auto-refresh-label">
              <input
                type="checkbox"
                checked={autoRefresh}
                onChange={(e) => onAutoRefreshChange(e.target.checked)}
              />
              Auto Refresh
              {autoRefresh && <span className="auto-refresh-dot" />}
            </label>
          </div>
          <button className="create-button" onClick={onCreateClick}>
            + Create Pallet
          </button>
        </div>
      </div>

      <PageToolbar
        viewMode={viewMode}
        onViewModeChange={onToggleView}
        searchTerm={searchTerm}
        searchPlaceholder="Search by pallet #, customer, item name..."
        onSearchChange={onSearchChange}
        showScanButton={true}
        onScan={onScan}
      >
        <select
          className="filter-select"
          value={statusFilter}
          onChange={(e) => onStatusFilterChange(e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="pending shipment">Pending Shipment</option>
          <option value="shipped">Shipped</option>
        </select>
        <select
          className="filter-select"
          value={customerFilter}
          onChange={(e) => onCustomerFilterChange(e.target.value)}
        >
          <option value="all">All Customers</option>
          {customers.map(customer => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </select>
        <select
          className="filter-select"
          value={labelFilter}
          onChange={(e) => onLabelFilterChange(e.target.value)}
        >
          <option value="all">All Labels</option>
          <option value="__none__">No Label</option>
          {labels.map(label => (
            <option key={label} value={label}>{label}</option>
          ))}
        </select>
        <div className="date-filter-wrapper">
          <input
            type="date"
            className="filter-date-input"
            value={dateFilter}
            onChange={(e) => onDateFilterChange(e.target.value)}
            title="Filter by date"
          />
          {dateFilter && (
            <button
              className="date-filter-clear"
              onClick={() => onDateFilterChange("")}
              title="Clear date filter"
            >
              �
            </button>
          )}
        </div>
      </PageToolbar>

      {/* Search totals banner - shows item quantities when searching */}
      {searchTotals && searchTotals.length > 0 && (
        <div className="search-totals-banner">
          <div className="search-totals-title">
            Items matching "{searchTerm}" in {statusFilter === 'all' ? 'all' : statusFilter} pallets:
          </div>
          <div className="search-totals-list">
            {searchTotals.slice(0, 5).map((item, index) => (
              <div key={index} className="search-total-item">
                <span className="item-name">{item.name}</span>
                <span className="item-stats">
                  <strong>{item.totalQty.toFixed(0)}</strong> cases
                  <span className="separator">•</span>
                  <strong>{item.totalWeight.toFixed(1)}</strong> kg
                  <span className="separator">•</span>
                  {item.palletCount} pallet{item.palletCount !== 1 ? 's' : ''}
                </span>
              </div>
            ))}
            {searchTotals.length > 5 && (
              <div className="search-totals-more">
                +{searchTotals.length - 5} more items...
              </div>
            )}
          </div>
        </div>
      )}

      {/* Filter summary - show when filtered */}
      {(customerFilter !== 'all' || searchTerm) && !searchTotals && (
        <div className="filter-summary">
          <span className="pallet-count">
            {filteredCount} pallet{filteredCount !== 1 ? 's' : ''}
            {customerFilter !== 'all' && (
              <> for <strong>{customers.find(c => c.id === parseInt(customerFilter))?.name}</strong></>
            )}
          </span>
        </div>
      )}
    </div>
  );
};

export default PalletsHeader;
